module.exports = __webpack_public_path__ + "img/2.ea7fb076.png";